import { lazyWeixinJsSdk } from '@utils/lazylib';
import { login } from '@bbtfe/webview-bridge';
import { isInMiniProgram } from './development';
import { Toast } from 'antd-mobile';

/**
 * 去登录
 * @param {*} successCallback //登录成功回调
 * @param {*} miniLoginUrl
 */
export const gotoLogin = (
  miniLoginUrl = '/pages/auth/index' // 默认美囤小程序登录链接
) => {
  if (bbtNative.isApp()) {
    // 跳转到app登录.
    login();
  } else if (isInMiniProgram()) {
    lazyWeixinJsSdk().then(wx => {
      wx.miniProgram.navigateTo({ url: miniLoginUrl });
    });
  } else {
    Toast.show('请下载最新的宝宝树孕育APP');
  }
};
